<div *ngIf="isDragAndDrop" ng2FileDrop [uploader]="dropZone.uploader" class="drop-zone" [ngClass]="{'file-over': isFileOver}"
  (fileOver)="setFileOver($event)" (onFileOver)="disableDropZone()" (onFileDrop)="onFileDrop($event)">
    <ng-content></ng-content>
</div>
<label *ngIf="!isDragAndDrop"> <input type="file" id="file" ng2FileSelect [uploader]="dropZone.uploader" multiple/></label>

  